<template>
  <v-container 
    v-if="!$apollo.loading"
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      v-if="!editFile"
      justify-center
      wrap
    >
      <v-flex
        xs12
        pr-0
        pl-0
        :class="{'text-right': downloadsFiles.length !== 0}"
      >
        <v-btn
          style="display:inline;margin-top:-6px;"
          small
          outlined
          @click="handleEditFile()"
        >
          <span v-if="downloadsFiles.length === 0">
            {{ $t('modules.filleAdd') }}
          </span>          
          <v-icon v-else>
            mdi-plus-circle-outline
          </v-icon>
        </v-btn>
      </v-flex>
      <v-flex
        v-if="downloadsFiles.length !== 0"
        pl-0
        pr-0
        xs12
      >
        <v-data-table
          class="text-no-wrap mb-7" 
          :headers="headers"
          :items="downloadsFiles"
          :hide-default-footer="true"
          :mobile-breakpoint="0"
          :items-per-page="200"
        >
          <template
            slot="headerCell"
            slot-scope="{ header }"
          >
            <span
              v-text="header.text"
            />
          </template>
          <template v-slot:item.name="{ item }">
            {{ item.name }}
          </template>                
          <template v-slot:item.actions="{ item, index }">
            <div class="text-right">
              <v-btn
                :disabled="$apollo.loading"
                class="mr-2"
                outlined 
                small
                text
                @click="handleEditFile(item, index)"
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
              <v-btn
                :disabled="$apollo.loading"
                outlined 
                small
                text
                @click="confirmDeleteFile(item, index)"
              >
                <v-icon>mdi-bucket-outline</v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex
        v-else
        class="not-found"
        xs12
      >
        <v-card>
          <v-icon>mdi-ghost</v-icon>
          <p>{{ $t('modules.fileEmpty') }}</p>
        </v-card>
      </v-flex>
    </v-layout>
    <new-or-edit-file
      v-if="editFile"
      :whitelabel-uuid="whitelabelUuid"
      :files-downloads="downloadsFiles"
      :file="selectedFile"
      :course="moduleLmsCourse"
      :position="selectedFilePosition"
      @closeEditFile="closeEditFile"
    />
    <helper-confirm-dialog
      v-if="confirmDialog"
      :show-dialog="confirmDialog"
      :text="$t('modules.fileReallyDelete', {name: selectedFile.name})"
      @closeConfirmDialog="closeConfirmDialog"
    />
  </v-container>
</template>
<script>
import COURSE_UPDATE_DOWNLOAD_MUTATION from "@/graphql/mutations/modules/CourseUpdateDownload.gql";
import LMS_COURSE_QUERY from "@/graphql/queries/modules/LmsCourse.gql";
import NewOrEditFile from './partial/NewOrEditFile.vue';

export default {
  name: 'FilesLabel',
  components: {
    NewOrEditFile
  },
  props: {
    whitelabelUuid: {
      type: String,
      default: null
    },
    courseId: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      loading: false,
      confirmDialog: false,
      editFile: false,
      selectedFile: null,
      selectedFilePosition: null,
      headers: [
        {
          sortable: false,
          text: this.$t('modules.fileName'),
          value: 'name'
        },
        {
          sortable: false,
          text: '',
          value: 'actions',
        },
      ]
    }
  },
  computed: {
    downloadsFiles() {  
      let downloadsFiles = [];

      if(this.moduleLmsCourse) {
        const formCourse = JSON.parse(JSON.stringify(this.moduleLmsCourse));

        if (formCourse && formCourse.downloads) {
          downloadsFiles = Array.isArray(formCourse.downloads) ? formCourse.downloads : JSON.parse(formCourse.downloads);
        }
      }
      return downloadsFiles;
    }
  },
  methods: {
    closeEditFile(isClose) {
      this.editFile = false;
      this.selectedFile = null;
      this.selectedFilePosition = null;
      this.$emit('handledIsOpenForm', false);
      if(isClose) this.$apollo.queries.moduleLmsCourse.refetch();
    },
    handleEditFile(item, index) {
      if(item) this.selectedFile = item;
      if(index) this.selectedFilePosition = index;
      this.editFile = true;
      this.$emit('handledIsOpenForm', true);
    },
    confirmDeleteFile(item, index) {
      this.confirmDialog = true;
      this.selectedFile = item;
      this.selectedFilePosition = index;
    },
    closeConfirmDialog(confirmed) {
      this.confirmDialog = false
      if (confirmed) {
        this.deletedFile();
      } else {
        this.selectedFile = null;
        this.selectedFilePosition = null;
      }
    },
    deletedFile(){
      this.loading = true;
      let courseDownload = this.moduleLmsCourse;
      let downloadsFiles = JSON.parse(courseDownload.downloads);
      downloadsFiles.splice(this.selectedFilePosition, 1);

      courseDownload.whitelabel_uuid = this.whitelabelUuid;
      courseDownload.course_uuid = courseDownload.uuid;
      courseDownload.downloads = downloadsFiles;
      
      if (!courseDownload.product_id) delete(courseDownload.product_id);
      if (courseDownload.uuid) delete(courseDownload.uuid);
      this.$apollo
        .mutate({
          mutation: COURSE_UPDATE_DOWNLOAD_MUTATION,
          variables: courseDownload
        })
        .then(data => {
          this.loading = false;
          this.selectedFile = null;
          this.selectedFilePosition = null;
          this.$store.commit('app/setNotifier', this.$t('globals.success')); 
          this.$apollo.queries.moduleLmsCourse.refetch();         
        })
        .catch(error => {
          this.errorHandler(error);
          this.loading = false;
          this.selectedFile = null;
          this.selectedFilePosition = null;
        });
    },
    save() {
      if(this.course) {
        this.$emit('closeCourseForm', true);
      } else {
        this.$emit('nextStep', this.whitelabelUuid, this.courseId);;
      }      
    }
  },
  apollo: {
    moduleLmsCourse: {
      fetchPolicy: "network-only",
      query() {
        return LMS_COURSE_QUERY;
      },
      variables() {
        return {
          whitelabel_uuid: this.whitelabelUuid,
          course_id: this.courseId
        }
      },
      skip() {
        return !this.whitelabelUuid || !this.courseId;
      },
    }
  },
}
</script>
<style lang="sass" scoped>

</style>